// 按需全局引入 vant组件
import Vue from 'vue'
import { Button, List, Cell, CellGroup, Tabbar, TabbarItem, Form, Field, Notify, Toast, Lazyload, Icon, PullRefresh, Tag, Tab, Tabs, Image } from 'vant'
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(List)
Vue.use(Form)
Vue.use(Field)
Vue.use(Notify)
Vue.use(Toast)
Vue.use(Tag)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Image)
Vue.use(Lazyload, {
  lazyComponent: true,
})
Vue.use(Icon)
Vue.use(PullRefresh)
Vue.use(Tabbar).use(TabbarItem)
